export default function WeekendHome() {
  return (
    <div className="w3-container"></div>
  )
}
